import styled from 'styled-components';
import Styled from "styled-components";

export const SearchHotelsContainer = styled.div`
    padding-top: 125px;
    margin-bottom: 80px;
    
    display: flex;
    flex-direction: column;
    
    .card-search {
        border: 0;
        border-radius: 0;
        box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
        
        padding: 1.5rem 1.5rem 2.5rem; 
        display: grid;
        gap: 1rem;
    }
`

export const Banner = Styled.div`

margin-bottom: 60px;
height: 290px;

img { 
    width: 100%;
    height: 100%;
    min-height: 100px;
    object-fit: cover;
}

.carousel-control-prev-icon{
    background-image: none !important;
}

.carousel-control-next-icon{
    background-image: none !important;
}

.carousel-indicators [data-bs-target] {
 background-color: rgba(5, 9, 34, 0.16) !important;
}

.carousel-indicators {
    align-items: center;
    margin-bottom: -52px !important;
}

.carousel-indicators .active {
    background-color: #050922 !important;
    width: 8px !important;
    height: 8px !important;
}

button{
    width: 6px !important;
    height: 6px !important; 
    background-color: #FFFFFF !important;
    border-radius: 100% !important;
}

`